/** 月一覧を返す（例: [1, 2, ..., 12] */
export const getMonths = (): number[] => {
    return Array.from({ length: 12 }, (_, i) => i + 1);
};

/** 日一覧を返す（例: [1, 2, ..., 31] */
export const getDays = (): number[] => {
    return Array.from({ length: 31 }, (_, i) => i + 1);
};

/** ユーザーの生まれ年として選択可能な値を返す */
export const getBirthdayYearOptions = (): number[] => {
    const from = 1920;
    const today = new Date();
    const minAge = 18;
    const to = today.getFullYear() - minAge + 1;
    return Array.from({ length: to - from }, (_, i) => from + i);
};

const isLeapYear = (y: number) => (y % 4 === 0 && y % 100 !== 0) || y % 400 === 0;
const datesOfYear = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const getEndOfMonth = (year: number, month: number): number => {
    if (isLeapYear(year) && month === 2) {
        return 29;
    } else {
        return datesOfYear[month - 1];
    }
};

/** 年月に照らしわせて、日が有効かどうか */
export const isValidDay = (year: number, month: number, day: number): boolean => {
    return day >= 1 && day <= getEndOfMonth(year, month);
};
